var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject } from "aurelia-framework";
import { TokenClient } from "../../../services/authentication/token-client.service";
import { transient } from "aurelia-dependency-injection";
import { Router } from "aurelia-router";
import { NotificationClientService, NotificationType } from "../../../services/basics/notification-client.service";
import { GenesisRouterConstants } from "../../../configuration/router.constants";
import { I18N } from 'aurelia-i18n';
import { EntityValidationsService } from "../../../client-validation-system/validations-service";
import { ValidationTypeEnum, ValidationActivation } from "../../../client-validation-system/validations.models";
var Login = /** @class */ (function () {
    function Login(tokenClient, notificationClientService, entityValidationsService, router, i18N) {
        this.tokenClient = tokenClient;
        this.notificationClientService = notificationClientService;
        this.entityValidationsService = entityValidationsService;
        this.router = router;
        this.i18N = i18N;
        this.providerHandlers = [];
    }
    Login.prototype.activate = function (params, navigationInstruction) {
        this.canSignup = navigationInstruction.canSignup;
        this.returnUrl = params.returnUrl ? params.returnUrl : null;
        this.canLoginWithProviders = navigationInstruction.canLoginWithProviders;
        this.providerHandlers = navigationInstruction.providerHandlers;
    };
    Login.prototype.attached = function () {
        var rulesHolder = {
            activation: ValidationActivation.Always,
            entityName: "Login",
            isCollection: false,
            nestedRulesHolder: [],
            rules: [{
                    errorMessage: this.i18N.tr('email-required-text'),
                    parameters: null, property: "email",
                    validationType: ValidationTypeEnum.Required
                }, {
                    errorMessage: this.i18N.tr('email-invalid-text'),
                    parameters: null, property: "email",
                    validationType: ValidationTypeEnum.Email
                }, {
                    errorMessage: this.i18N.tr('password-required-text'),
                    parameters: null, property: "password",
                    validationType: ValidationTypeEnum.Required
                }]
        };
        this.validator = this.entityValidationsService.getValidator(this, rulesHolder);
    };
    Login.prototype.forgotPassword = function () {
        this.router.navigateToRoute(GenesisRouterConstants.RouteNames.ForgotPassword);
    };
    Login.prototype.register = function () {
        var queryString = location.href.split('?');
        if (queryString.length > 1) {
            var queryStringObj_1 = {};
            queryString[1].split('&').forEach(function (z) {
                var key = z.split('=')[0];
                var value = z.split('=')[1];
                queryStringObj_1[key] = value;
            });
            this.router.navigateToRoute(GenesisRouterConstants.RouteNames.Register, queryStringObj_1);
        }
        else {
            this.router.navigateToRoute(GenesisRouterConstants.RouteNames.Register);
        }
    };
    Login.prototype.submit = function () {
        var _this = this;
        this.submitting = true;
        return new Promise(function (resolve, reject) {
            _this.validator.validate().then(function (validationResponse) {
                if (validationResponse.valid) {
                    _this.tokenClient.login({
                        email: _this.email,
                        password: _this.password
                    }).then(function () {
                        resolve();
                        _this.submitting = false;
                        location.reload();
                    }, function (error) {
                        var localeKey = "login-error-".concat(error.content.reasonPhrase, "-text");
                        _this.notificationClientService.show(_this.i18N.tr('login-failed-text'), error.content, NotificationType.Error);
                        if (error.content.reasonPhrase == "password-expired") {
                            _this.router.addRoute({
                                moduleId: "./views/pages/authentication/change-password",
                                name: "change-password",
                                route: "change-password/:token?",
                                title: _this.i18N.tr("change-password-text"),
                                auth: false
                            });
                            _this.router.navigateToRoute("change-password", { token: error.headers.get("token") });
                            resolve();
                        }
                        else {
                            reject();
                        }
                        _this.submitting = false;
                    });
                }
                else {
                    //this.notificationClientService.show(this.i18N.tr('login-failed-for-user-text') + " " + this.email, "", NotificationType.Error);
                    reject();
                    _this.submitting = false;
                }
            }).catch(function (ex) {
                reject();
                _this.submitting = false;
            });
        });
    };
    Login = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [TokenClient,
            NotificationClientService,
            EntityValidationsService,
            Router,
            I18N])
    ], Login);
    return Login;
}());
export { Login };
